// api/common/InventoryHub.ts
import * as signalR from '@microsoft/signalr';
import { API_BASE_URL } from '../config';

/**
 * Minimal, direct SignalR client for ProductService's InventoryHub (/hubs/inventory)'s
 * `OnLowStock` event — same proven, direct pattern MessagesHub.ts uses instead of
 * SignalRServiceBase (see that file's doc comment for why: untested boilerplate that invokes a
 * `Heartbeat` method no real hub exposes).
 */
export interface LowStockPayload {
  productId: string;
  name: string;
  sku: string;
  quantityAfter: number;
  minStockLevel: number;
}

/** Connects and starts listening. Caller owns the connection — call `.stop()` on cleanup. */
export function connectInventoryHub(
  accessToken: string,
  onLowStock: (payload: LowStockPayload) => void
): signalR.HubConnection {
  const connection = new signalR.HubConnectionBuilder()
    .withUrl(`${API_BASE_URL}/hubs/inventory`, { accessTokenFactory: () => accessToken })
    .withAutomaticReconnect()
    .configureLogging(signalR.LogLevel.Warning)
    .build();

  connection.on('OnLowStock', onLowStock);

  connection.start().catch((err) => {
    console.error('[InventoryHub] connection failed:', err);
  });

  return connection;
}
